import {
    type IDirectoryAsset,
    type IDirectoryCompany,
    type INexusAsset,
    type INexusCompany,
    type IPrivateAsset,
    type IPrivateCompany,
    type IPrivateConsumerHealthAsset,
    type IPrivateTechnology,
    type NexusSource
} from '@inpart-io/padme-iap';
import { type QInfiniteScroll } from 'quasar';
import { type ComputedRef } from 'vue';

export type SelectableCompany = IPrivateCompany | IDirectoryCompany | INexusCompany;
export type SelectableAsset = IPrivateAsset | IDirectoryAsset | IPrivateTechnology | IPrivateConsumerHealthAsset | INexusAsset;

export const sourceValues = {
    DATA: 'DATA'
} as const;
export type LocalSource = keyof typeof sourceValues;
export type Source = LocalSource | NexusSource;

export interface ISourceTab<T extends SelectableCompany | SelectableAsset> {
    [x: string]: unknown;
    name: string;
    count: number;
    searchResults: T[];
    recentResults?: T[];
    scrollEnded?: boolean;
    infiniteScroll?: QInfiniteScroll | null;
    hideCondition?: ComputedRef<boolean>;
}
